export const BuildInfo = {timestamp:1792513958000}
